<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: false,
      default: null,
    },
    activeIndex: {
      type: Number,
      required: false,
      default: null,
    },
    isActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasHelp: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  computed: {
    slideNumber() {
      const number = this.index + 1
      return number ? number.toString().replace(/^([0-9])$/, '0$1') : ''
    },
  }
}
</script>

<template>
  <header>
    <div :class="$style.wrapper">
      <div :class="$style.inner">
        <div :class="$style.number">{{ slideNumber }}.</div>
        <div>
          <span :class="$style.title"
            ><span>{{ title }}</span
            ><BaseIcon v-if="hasHelp" name="question-mark" :size="18" :class="$style.questionMark" @click="$emit('help')" /></span>
          <hr :class="$style.line" />
        </div>
      </div>
    </div>
  </header>
</template>

<style lang="scss" module>
@import '@design';

.wrapper {
  z-index: 2;
  margin: 0 auto;
  margin-bottom: $size-grid-size * 3;
  font-weight: bold;
  color: $color-text;

  @extend %typography-medium;

  @media screen and (min-width: $size-breakpoint-md) {
    height: 101px;
  }
}
.inner {
  display: flex;

  @media screen and (min-width: $size-breakpoint-md) {
    position: fixed;
    top: 15vh;
  }
}
.number {
  position: absolute;

  @media screen and (min-width: $size-breakpoint-md) {
    position: relative;
    width: $size-grid-size * 9;
  }
}
.title {
  display: flex;
  align-items: center;
  padding-left: $size-grid-size * 4;

  @media screen and (min-width: $size-breakpoint-md) {
    padding-left: 0;
  }
}
.line {
  display: block;
  width: $size-grid-size * 16;
  height: 4px;
  margin: 0;
  margin-top: $size-grid-size * 2;
  background-color: $color-highlight;
  border: none;
}
.questionMark {
  margin-left: $size-grid-size;
  cursor: pointer;
}
</style>
